import * as React from 'react';
import ErrorMessageComponent from 'src/modules/commons/error-messages/ErrorMessages.component';
import '../Modals.css';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';

export interface PasswordRecoveryProps {
  handleChange: (key: string) => ((value: string | boolean) => void);
  handleSubmit: () => void;
  login: () => void;
  errorMessage: {};
  modalRef?: Modal;
}

const PasswordRecoveryComponent: React.StatelessComponent<PasswordRecoveryProps> = (
  props: PasswordRecoveryProps
) => (
    <div className="modal-content">
      <div className="modal-header">
        <p className="text-right">
          <span
            className="close-med pointer"
            onClick={() => props.modalRef!.modal('hide')}
          />
        </p>
        <img
          src="/img/the-crowd-angel.png"
          alt="logo"
        />
        <div className="gap-20" />
        <hr />
      </div>
      <div className="modal-body">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            props.handleSubmit();
          }}
        >
          <h3 className="deco-title c-black-text">
            Recuperar Contraseña
          </h3>
          <div className="gap-20" />
          <p>
            <strong>
              ¿Has olvidado la contraseña?
            </strong>
            <br />
            No te preocupes, solo tienes que seguir los siguientes pasos para obtener una nueva contraseña.
          </p>
          <div className="gap-20" />
          <div className="md-input">
            <input
              className="md-form-control"
              required={true}
              type="text"
              onChange={(e) => props.handleChange('email')(e.target.value)}
            />
            <span className="highlight" />
            <span className="bar" />
            <label>
              Introduce el Email con el que te registraste *
            </label>
          </div>
          <div className="gap-20" />
          <button
            type="submit"
            className="btn btn-primary"
          >
            Enviar
          </button>
          <div className="gap-20" />
          <ErrorMessageComponent
            errorMessage={props.errorMessage}
          />
        </form>
      </div>
      <div className="modal-footer">
        <div className="gap-10" />
        <p className="text-center">
          Upps! ya me acordé de mi contraseña&nbsp;
        <a
          className="pointer"
          onClick={() => props.login()}
        >
          Iniciar sesión
          <span className="arrow-right-primary-dark" />
        </a>
        </p>
      </div>
    </div>
  );

export default PasswordRecoveryComponent;



// WEBPACK FOOTER //
// ./src/modules/modals/password-recovery/PasswordRecovery.component.tsx